import { fg } from '@townsquare/stat-sig/gate';

export const useIsForYouRefreshed = (): boolean => {
	return fg('townsquare_for_you_refresh');
};
